/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Previous_RoundsInputs */



/**
* | output |
* | --- |
* | "Previous rounds" |
*
* @param {Tournament_Previous_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_previous_rounds = /** @type {((inputs?: Tournament_Previous_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Previous_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes précédentes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas anteriores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas anteriores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round precedenti")
	return /** @type {LocalizedString} */ ("Previous rounds")
});